
import React from "react";
import Layout from "@/components/layout/Layout";
import { SectionHeader } from "@/components/ui/section-header";
import { SEOHead } from "@/components/seo/SEOHead";
import FairDealCalculator from "@/components/calculator/FairDealCalculator";
import { Button } from "@/components/ui/button";
import { InfoIcon } from "lucide-react";

export default function CalculatorPage() {
  return <Layout>
      <SEOHead 
        title="Fair Deal Calculator | Grandpal"
        description="Estimate your potential contribution under the Nursing Homes Support Scheme (Fair Deal) with our calculator."
        canonicalUrl="/fair-deal-calculator"
      />
      
      <div className="bg-gradient-to-b from-white to-grandpal-beige/20 py-12 md:py-16">
        <div className="container max-w-6xl">
          <div className="flex items-center justify-center gap-3 mb-2">
            <InfoIcon className="w-6 h-6 text-grandpal-green-dark\n" />
            <span className="text-sm font-medium uppercase tracking-wider text-grandpal-green-dark">Nursing Home Cost Calculator</span>
          </div>
          
          <SectionHeader title="Fair Deal Scheme Calculator" subtitle="Estimate your potential contribution under the Nursing Homes Support Scheme." centered className="mb-8" />

          <div className="bg-white rounded-lg shadow-md overflow-hidden border border-grandpal-beige mb-10">
            <div className="bg-grandpal-green/10 p-5 border-b border-grandpal-beige">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 bg-grandpal-green/20 p-2 rounded-full">
                  <InfoIcon className="w-6 h-6 text-grandpal-green-dark" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-grandpal-green-dark mb-1">About the Fair Deal Scheme</h3>
                  <p className="text-grandpal-gray text-sm">
                    The Nursing Home Support Scheme (NHSS), commonly known as the Fair Deal scheme, helps 
                    pay for the cost of nursing home care. Under this scheme, you contribute an amount based 
                    on your means (income and assets), and the HSE covers the rest of the nursing home costs as State support.
                  </p>
                </div>
              </div>
            </div>

            <FairDealCalculator />
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-grandpal-beige">
              <h3 className="text-xl font-semibold text-grandpal-green-dark mb-4">Fair Deal Guide</h3>
              <p className="text-grandpal-gray mb-6">
                Download our comprehensive guide to the Fair Deal Scheme for detailed information on eligibility, application process, and more.
              </p>
              <Button variant="outline" className="w-full border-grandpal-green-dark text-grandpal-green-dark hover:bg-grandpal-green/10">
                Download Free Guide
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}
